import React from 'react';
import logo from '../assets/logo/logo.png';
import { GoogleForms } from "../components/googles-forms";
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";

const AccountLessApply = () => {

    return (
        <>
            <Helmet>
                <title>AGFA | AIA-APPY</title>
                <meta name="description" content="Apply for scholarships and study opportunities in China and India with ARTHUR GOOGLE FORMS APPLICATION (AGFA). Start your journey abroad today." />
            </Helmet>
            <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', paddingTop: 80, paddingBottom: 40 }}>
                <div className="header" style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #1e3c72 100%)',
                    color: '#fff',
                    padding: '12px 20px',
                    zIndex: 1001,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '16px',
                    borderBottom: '2px solid #4a90e2',
                    flexWrap: 'wrap',
                }}>
                    {/* Logo and Title */}
                    <div style={{
                        display: 'flex',
                        // alignItems: 'center',
                        gap: '16px',
                        margin: '0 auto'
                    }}>
                        <img src={logo} alt="logo" width="55px" style={{
                            borderRadius: '8px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                            border: '2px solid #4a90e2',
                            backgroundColor: '#ffffff'
                        }} />
                        <h1 style={{
                            color: "#ffffff",
                            margin: 0,
                            fontSize: '1.8rem',
                            fontWeight: '700',
                            // textAlign: 'center',
                            textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                            letterSpacing: '1px',
                            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
                        }}>
                            ARTHUR GOOGLE FORM APPLICATION (AGFA)
                        </h1>
                    </div>
                </div>
                <br />
                <center><Link to="/">
                    <button style={{ padding: "10px", borderRadius: "12px", color: "white", backgroundColor: "inherit" }}>BACK TO HOME</button>
                </Link></center>
                <GoogleForms />
                <br />
                <footer style={{ textAlign: 'center', marginTop: 40, color: '#fff' }}>
                    &copy; {new Date().getFullYear()} Arthur International Agency. All rights reserved.
                </footer>
            </div>
        </>
    );
};

export default AccountLessApply;